import CheveronLeftBold from "shared/icons/CheveronLeftBold";
import { useHistory } from "react-router-dom";

interface TournamentChatHeaderProps {
  groupName: string;
  roundSequence: number;
  teamIdToColor: Record<string, string>;
}

export default function TournamentGroupChatHeader({
  groupName,
  roundSequence,
  teamIdToColor,
}: TournamentChatHeaderProps) {
  const history = useHistory();
  const handleBackClick = () => {
    history.goBack();
  };

  return (
    <div className={"tournament-chat-conatainer"}>
      <div onClick={handleBackClick} className="back-button">
        <CheveronLeftBold fontSize={16} />
      </div>
      <div className={"tournament-chat-wrapper"}>
        <h6 className="group-chat-title" style={{ color: "white" }}>
           Round {roundSequence} -  {groupName}
        </h6>
      </div>
    </div>
  );
}
